module.exports = __webpack_public_path__ + "static/1- counselling-1a4a3c40ca9910d676b1972f46adef0d.png";